const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIronstoneLogoNoTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 210 281",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2261,-71.4153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Page-1",
    x: 0,
    y: 0,
    width: 3013.13,
    height: 536.604,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2390,249.047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-177.632L0,-156.272L11.243,-76.072L81,0L81,-106.131L14.004,-177.632L0,-177.632Z",
    style: {
      fill: "rgb(247,185,18)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2283.38,352.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-280L-22.376,-280L-22.376,0L57.624,0L57.624,-34.746L46.479,-129L53.246,-129L94.241,0L187.624,0L187.624,-78.334L109.97,-162.599L0,-280Z",
    style: {
      fill: "rgb(52,52,51)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronstoneLogoNoTitle);
export default __webpack_public_path__ + "static/media/ironstone_logo_no_title.dee3fbeb411f3890a574f57db57e9953.svg";
export { ForwardRef as ReactComponent };